const contactCards = [
    {
        id: 1,
        icon: './assets/icons/envelope-fill.svg',
        title: 'Email',
        description: 'contactus@pr-builders.in',
        url: 'mailto: contactus@pr-builders.in'
    },
    {
        id: 2,
        icon: './assets/icons/telephone-fill.svg',
        title: 'Phone',
        description: '+91 8610074336',
        url: 'tel:8610074336'
    },
    {
        id: 3,
        icon: './assets/icons/building-fill.svg',
        title: 'Address',
        description: 'PR Builders, Vengadamangalam, near East Tambaram, Chennai — Tamil Nadu 600127',
        url: null
    },
];

export default contactCards;
